export default __webpack_public_path__ + "static/media/creation-process.b0164935.gif";